import TransWithNda from './TransWithNda.component';

export default TransWithNda;